module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-attachment"
  }, _vm._l((_vm.item.attachments), function(attachment) {
    return _c('div', {
      staticClass: "driver-license-attachment"
    }, [_c('dropdown', {
      staticClass: "float-right",
      attrs: {
        "icon": 'fa fa-ellipsis-v fa-2x action',
        "position": 'bottom'
      }
    }, [_c('driver-license-attachment-action-buttons', {
      attrs: {
        "licenseId": _vm.item.id,
        "attachmentId": attachment.id,
        "attachmentUrl": attachment.url
      }
    })], 1), _c('img', {
      attrs: {
        "src": attachment.url
      }
    })], 1)
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a593055!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverLicenseAttachment.vue
// module id = 2418
// module chunks = 1